import Eyebrow from '@Guidelines/Component/Eyebrow';
import { theme } from '@Guidelines/Theme/theme';
import type ImportedDocumentEvidenceView from '@UI/Store/Documents/Views/ImportedDocumentEvidenceView';
import { css } from '@emotion/react';
import type * as React from 'react';

const cardStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	padding: 1rem 1.125rem;
	border-radius: ${theme.radii.medium};
	background-color: ${theme.colors.surfaceMuted};
`;

const nameStyle = css`
	margin: 0;
	font-family: ${theme.fonts.display};
	font-size: ${theme.fontSizes.large};
	color: ${theme.colors.ink};
`;

type Props = {
	readonly evidence: ImportedDocumentEvidenceView;
};

/** A field founded on an imported document: "Document importé" and the document's name. */
const ImportedDocumentEvidenceCard: React.FC<Props> = ({ evidence }) => (
	<div css={cardStyle}>
		<Eyebrow>Document importé</Eyebrow>
		<p css={nameStyle}>{evidence.name}</p>
	</div>
);

export default ImportedDocumentEvidenceCard;
